import {Injectable} from "@angular/core";
import {AppService} from "@irb/app.service";
import {
    IPortfolioResultResponse,
    IPortfolioResultACCRebal,
    IPortfolioResultDialogData,
    IPortfolioResultSECRebal,
    IPortfolioResultCheckValidationConfiguration
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {IAlertDialogData} from "@irb/app.model";
import {IrbAppEvents} from "@irb/app.events";
import {throwError} from "rxjs";
import {PrUtilityService} from "@irb/irb-editors/editor-portfolio-result/services/pr-utility.service";
import {PrOrdersService} from "@irb/irb-editors/editor-portfolio-result/services/pr-orders.service";
import {CurrencyPipe} from '@angular/common';

@Injectable({
    providedIn: "root"
})
export class PrValidationService {
    validationInProgress: boolean = false;
    pendingFunction: Function | undefined;
    isUnitTest: boolean = false;

    constructor(
        private as: AppService,
        private prutil: PrUtilityService,
        private pros: PrOrdersService,
        private cp: CurrencyPipe
    ) {
    }

    checkValidation(config: IPortfolioResultCheckValidationConfiguration) {
        this.validationInProgress = true;

        if (typeof config.callStack === "undefined") {
            config.callStack = [];
        }

        // console.log("validate:", config.validnFor, config.callStack, config.item);

        if (config.callStack.indexOf(config.validnFor) === -1) {
            config.callStack.push(config.validnFor);
        } else {
            config.onComplete(config.callStack, config.item);
            return;
        }

        const secSymb = config.item.secSymbol;
        const secAccNum = config.item.accountNum;
        const buyUnheldSecurity = config.item.buyUnheldSecurity;
        const hasChildren = (config.item.lotRebalanceSummaryDTOList && config.item.lotRebalanceSummaryDTOList.length > 0) ? true : false;
        let cashItem: IPortfolioResultACCRebal;
        const secExclusionType = config.item.secExclusionType;
        const isExcludedPosition = secExclusionType === "EXCLUDED";
        const quantity = config.item.quantity;
        const marketValue = config.item.mktValue;
        const curQuotePrice = config.item.currMarketPrice;

        const dialogData = {} as IPortfolioResultDialogData;
        dialogData.tradeItem = config.item;
        dialogData.lotItem = config.lotItem;
        dialogData.lotSnapShotItem = config.lotSnapShotItem;
        dialogData.beforeChangeTxnType = config.snapShotItem.txnType || "NONE";
        dialogData.beforeChangeTxnAmt = config.snapShotItem.txnAmt || 0;
        dialogData.beforeChangeTxnShares = config.snapShotItem.txnShares || 0;
        dialogData.txnType = config.item.txnType;
        dialogData.txnAmt = config.item.txnAmt;
        dialogData.userTxnComplete = config.item.userTxnComplete;
        dialogData.hasChildren = hasChildren;
        dialogData.buyUnheldSecurity = buyUnheldSecurity;
        dialogData.title = "Warning";
        dialogData.cancelLabel = 'Cancel';
        dialogData.onComplete = config.onComplete;
        dialogData.onCancel = config.onCancel;
        dialogData.callStack = config.callStack;

        config.data.accRebalDTOList.forEach((c: IPortfolioResultACCRebal) => {
            if (c.accountNum === config.item.accountNum) {
                cashItem = c;
            }
        });

        if (!cashItem && !this.isUnitTest) {
            throwError("IPortfolioResultACCRebal not found for " + config.item.accountNum);
            return;
        }

        if (config.validnFor === "equityTradeMinimum" && config.item.secType && config.item.secType === "EQ" && config.item.txnType !== "NONE") {
            dialogData.dialogFor = "equityTradeMinimum";
            dialogData.title = "Warning";
            let curSharePrice = 0;
            let warningrqd = false;

            if (curQuotePrice !== null && curQuotePrice > 0) {
                curSharePrice = curQuotePrice;
            }

            if (marketValue !== null && quantity !== null && marketValue > 0 && quantity > 0) {
                curSharePrice = parseFloat((marketValue / quantity).toFixed(2));
            }

            if (curSharePrice !== null && config.item.txnAmt < curSharePrice) {
                warningrqd = true;

                if (dialogData.buyUnheldSecurity) {
                    dialogData.message = "The share price for " + secSymb + " is approximately $" + curSharePrice + ". You can bypass this warning if desired.";
                } else {
                    dialogData.message = "The share price for " + secSymb + " was approximately $" + curSharePrice + " at the time of submission. You can bypass this warning if desired.";
                }
            }

            if (warningrqd) {
                this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
            } else {
                config.validnFor = "sellRestricn";
                this.checkValidation(config);
                //(config.data, config.item, config.snapShotItem, "sellRestricn", dialogData.on, dialogData.callStack);
            }
        } else if (config.validnFor === "excluded") {
            if (isExcludedPosition) {
                dialogData.dialogFor = "excluded";
                dialogData.message = "The Security " + secSymb + " is excluded. You can bypass this warning if desired.";
                this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
            } else if (dialogData.onComplete) {
                dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
            }
        } else if (config.validnFor === "sellRestricn") {
            if (dialogData.txnType === "SELL" || dialogData.txnType === "SELL ALL" || dialogData.txnType === "BUY") {
                const isSellRestricn = config.item.sellRestricn;
                const isBuyRestricn = config.item.buyRestricn;
                const portfolioRestricn = config.item.portfolioRestricn;
                const modelRestricn = config.item.modelRestricn;
                const secMasterRestricn = config.item.secMasterRestricn;
                const ccDNSRestriction = config.item.ccDNSRestriction;

                if (isSellRestricn && isBuyRestricn) {
                    dialogData.dialogFor = "sellRestricn";

                    if (portfolioRestricn) {
                        dialogData.message = "There is a restriction specified for this portfolio to never buy and never sell "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (modelRestricn) {
                        dialogData.message = "There is a restriction specified in the model for this portfolio to never buy and sell "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (secMasterRestricn) {
                        dialogData.message = "There is a Global Restriction on the Security " + secSymb + " to never buy and sell "
                            + ". You can bypass this warning if desired.";
                    }

                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (ccDNSRestriction && (dialogData.txnType === "SELL" || dialogData.txnType === "SELL ALL")) {
                    dialogData.dialogFor = "sellRestricn";

                    dialogData.message = "Some shares of security " + secSymb + " were set to never sell in account " + secAccNum + " because there was a covered call written against it. Please see explanation report for details or you can bypass this warning if&nbsp;desired.";

                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (dialogData.txnType === "BUY" && isBuyRestricn) {
                    dialogData.dialogFor = "sellRestricn";

                    if (portfolioRestricn) {
                        dialogData.message = "There is a restriction specified for this portfolio to never buy "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (modelRestricn) {
                        dialogData.message = "There is a restriction specified in the model for this portfolio to never buy "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (secMasterRestricn) {
                        dialogData.message = "There is a Global Restriction on the Security " + secSymb + " to never buy."
                            + " You can bypass this warning if desired.";
                    }

                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if ((dialogData.txnType === "SELL" || dialogData.txnType === "SELL ALL") && isSellRestricn) {
                    dialogData.dialogFor = "sellRestricn";

                    if (portfolioRestricn) {
                        dialogData.message = "There is a restriction specified for this portfolio to never sell "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (modelRestricn) {
                        dialogData.message = "There is a restriction specified in the model for this portfolio to never sell "
                            + secSymb + ". You can bypass this warning if desired.";
                    } else if (secMasterRestricn) {
                        dialogData.message = "There is a Global Restriction on the Security " + secSymb + " to Never Sell."
                            + ". You can bypass this warning if desired.";
                    }

                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (dialogData.buyUnheldSecurity) {
                    config.validnFor = "noTradeAccountForBuyUnheldSec";
                    this.checkValidation(config);
                } else {
                    config.validnFor = "noTradeAccount";
                    this.checkValidation(config);
                }

            } else if (dialogData.txnType === "NONE") {
                config.validnFor = "negativeCash";
                this.checkValidation(config);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (config.validnFor === "noTradeAccount") {
            if (!cashItem.noTradeWarningShown) {
                const frozen = cashItem.frozen;
                const blocked = cashItem.blocked;

                if (frozen) {
                    dialogData.dialogFor = "noTradeAccount";
                    dialogData.title = "Frozen Account";
                    dialogData.message = "This account is marked as frozen either in iRebal or Schwab Advisor Center. For information about the reason, check the explanation report for this result by clicking view at the top of the page. You can override this warning, but Schwab Advisor Center may reject any submitted orders.";
                    cashItem.noTradeWarningShown = true;
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (blocked) {
                    dialogData.dialogFor = "noTradeAccount";
                    dialogData.title = "Blocked Account";
                    dialogData.message = "This account is marked as blocked in Schwab Advisor Center. You can override this warning, but Schwab Advisor Center may reject any submitted orders.";
                    cashItem.noTradeWarningShown = true;
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (config.item.txnAmt !== 0 && config.item.userTxnComplete) {
                    config.validnFor = "sellOrBuyMin";
                    this.checkValidation(config);
                } else {
                    if (dialogData.onComplete) {
                        dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                    }
                }
            } else if (config.item.txnAmt !== 0 && config.item.userTxnComplete) {
                config.validnFor = "sellOrBuyMin";
                this.checkValidation(config);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (config.validnFor === "sellOrBuyMin") {
            /*
             * Logic - RCR 311 - MIN175
             * The Min Buy% and Min Sell% will be calculated by Min Buy%/ Min Sell% * Portfolio Baseline Value.
             * The logic will take the greater of the Security Min % (calculated with formula above) or the MinBuy $/MinSell $ for the Advisor Imposed Buy/Sell Mins.
             */
            const sellOrBuyMinObject: any = {};
            sellOrBuyMinObject.portfolioBaselineValue = config.data.preRebalPfMktValue; // Portfolio Market Value

            // Sell
            sellOrBuyMinObject.sellMinAmt = config.item.sellMinAmt;
            sellOrBuyMinObject.sellMinPerc = config.item.sellMinPerc;
            sellOrBuyMinObject.sellMinPercToAmt = ((sellOrBuyMinObject.sellMinPerc / 100) * sellOrBuyMinObject.portfolioBaselineValue); // convert % to $

            //Check GreaterAmt between % Value & $ value
            sellOrBuyMinObject.sellMinGreaterAmt = ((sellOrBuyMinObject.sellMinPercToAmt > sellOrBuyMinObject.sellMinAmt) ? sellOrBuyMinObject.sellMinPercToAmt : sellOrBuyMinObject.sellMinAmt);
            sellOrBuyMinObject.sellMinGreaterAmt = this.prutil.roundDecNumber(sellOrBuyMinObject.sellMinGreaterAmt, 2); // round the final value

            // Buy
            sellOrBuyMinObject.buyMinAmt = config.item.buyMinAmt;

            sellOrBuyMinObject.buyMinPerc = config.item.buyMinPerc;
            sellOrBuyMinObject.buyMinPercToAmt = ((sellOrBuyMinObject.buyMinPerc / 100) * sellOrBuyMinObject.portfolioBaselineValue);// convert % to $

            //Check GreaterAmt between % Value & $ value
            sellOrBuyMinObject.buyMinGreaterAmt = ((sellOrBuyMinObject.buyMinPercToAmt > sellOrBuyMinObject.buyMinAmt) ? sellOrBuyMinObject.buyMinPercToAmt : sellOrBuyMinObject.buyMinAmt);
            sellOrBuyMinObject.buyMinGreaterAmt = this.prutil.roundDecNumber(sellOrBuyMinObject.buyMinGreaterAmt, 2);// round the final value

            const initialBuyAmt = config.item.initialMinPurchaseAmt;
            const subsequentBuyAmt = config.item.subsMinPurchaseAmt;

            if (dialogData.txnType === "BUY") {
                const warningReqd = this.prutil.isAdvsrMinBuyWarningReqd(config.item.txnAmt, initialBuyAmt, subsequentBuyAmt, hasChildren);

                if (warningReqd && config.item.txnAmt < sellOrBuyMinObject.buyMinGreaterAmt) {
                    dialogData.dialogFor = "sellOrBuyMin";
                    dialogData.message = "The user-determined buy minimum for " + secSymb + " is $" + sellOrBuyMinObject.buyMinGreaterAmt + ". You can bypass this warning if desired.";
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else {
                    config.validnFor = "negativeCash";
                    this.checkValidation(config);
                }
            } else if (dialogData.txnType === "SELL" || dialogData.txnType === "SELL ALL") {
                if (config.item.txnAmt < sellOrBuyMinObject.sellMinGreaterAmt) {
                    dialogData.dialogFor = "sellOrBuyMin";
                    dialogData.message = "The user-determined sell minimum " + secSymb + " is $" + sellOrBuyMinObject.sellMinGreaterAmt + ". You can bypass this warning if desired.";
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else {
                    config.validnFor = "penaltyForSell";
                    this.checkValidation(config);
                }
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (config.validnFor === "fractionalShare") {
            if (dialogData.txnType === "SELL" && config.item.afterRebalShares < 2 && config.item.secType !== "MF") {
                dialogData.dialogFor = "fractionalShare";
                dialogData.message = "This order will be increased to a Sell All because after rounding, the remaining position quantity would be less than 1 share.";
                dialogData.cancelLabel = "Go Back";
                this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(true);
                }
            }
        } else if (config.validnFor === "negativeCash") {
            const availCash = cashItem.availCash;

            this.pros.getAfterRebalCashAmount(config.data, secAccNum, availCash, (remainingCashAmount: number) => {
                const ngtvCashWarningShown = cashItem.negativeCashWarningShown;

                if (remainingCashAmount < 0 && !ngtvCashWarningShown) {
                    cashItem.negativeCashWarningShown = true; //-ve cash warning once for an account on user-trade edit.
                    dialogData.dialogFor = "negativeCash";
                    dialogData.message = "The cash in account " + secAccNum + " has gone negative";
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (dialogData.txnType === "BUY") {
                    config.validnFor = "fundImposedMin";
                    this.checkValidation(config);
                } else {
                    if (dialogData.onComplete) {
                        dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                    }
                }
            });
        } else if (config.validnFor === "penaltyForSell") {
            const penaltyAmt = config.item.penaltyAmt;

            if (penaltyAmt && penaltyAmt > 0) {
                dialogData.title = "Commission or Penalty";
                dialogData.dialogFor = "penaltyForSell";
                dialogData.message = "Selling " + secSymb + " will result in a " + this.cp.transform(penaltyAmt) + " commission or penalty because the security was recently purchased";
                this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
            } else if (dialogData.txnType === "SELL") { //#63449
                config.validnFor = "negativeCash";
                this.checkValidation(config);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (config.validnFor === "fundImposedMin") {
            const buyMinAmt = config.item.buyMinAmt;

            if (dialogData.txnType === "BUY") {
                if (!hasChildren) { // if no children then it means that its 1st time purchase
                    const initialBuyAmt = config.item.initialMinPurchaseAmt;

                    if (config.item.txnAmt !== 0 && config.item.txnAmt < initialBuyAmt) {
                        dialogData.dialogFor = "fundImposedMin";
                        dialogData.message = "This fund must be initially purchased at a minimum of $" + initialBuyAmt
                            + ". You will not be able to approve this order.";
                        this.displayPfSummryDialog(config.data, dialogData);
                    } else {
                        if (dialogData.onComplete) {
                            dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                        }
                    }
                } else {
                    const subsequentBuyAmt = config.item.subsMinPurchaseAmt;

                    if (config.item.txnAmt < subsequentBuyAmt) {
                        dialogData.dialogFor = "fundImposedMin";
                        dialogData.message = "This fund must be subsequently purchased at a minimum of $" + subsequentBuyAmt
                            + ". You will not be able to approve this order.";

                        this.displayPfSummryDialog(config.data, dialogData);
                    } else {
                        if (dialogData.onComplete) {
                            dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                        }
                    }
                }
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (config.validnFor === "noTradeAccountForBuyUnheldSec") {
            if (!cashItem.noTradeWarningShown) {
                const frozen = cashItem.frozen;
                const blocked = cashItem.blocked;

                if (frozen) {
                    dialogData.dialogFor = "noTradeAccountForBuyUnheldSec";
                    dialogData.message = "This account is marked as frozen either in iRebal or Schwab Advisor Center. For information about the reason, check the explanation report for this result by clicking view at the top of the page. You can override this warning, but Schwab Advisor Center may reject any submitted orders.";
                    cashItem.noTradeWarningShown = true;
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else if (blocked) {
                    dialogData.dialogFor = "noTradeAccountForBuyUnheldSec";
                    dialogData.title = "Blocked Account";
                    dialogData.message = "This account is marked as blocked in Schwab Advisor Center. You can override this warning, but Schwab Advisor Center may reject any submitted orders.";
                    cashItem.noTradeWarningShown = true;
                    this.displayPfSummryConfDialog(config.data, config.item, config.snapShotItem, dialogData);
                } else {
                    config.validnFor = "sellOrBuyMin";
                    this.checkValidation(config);
                }
            } else {
                config.validnFor = "sellOrBuyMin";
                this.checkValidation(config);
            }
        } else {
            if (typeof config.onComplete !== "undefined") {
                config.onComplete(config.callStack, config.item);
            }
        }
    }

    completeValidation() {
        this.validationInProgress = false;
        
        if(typeof this.pendingFunction !== "undefined") {
            this.pendingFunction();
            this.pendingFunction = undefined;
        }
    }

    cancelValidation() {
        this.validationInProgress = false;
        this.pendingFunction = undefined;
    }

    displayPfSummryDialogCloseFunc(data: IPortfolioResultResponse, dialogData: IPortfolioResultDialogData, cbFunc?: Function) {
        if (dialogData.dialogFor === "fundImposedMin") {
            const beforeChangeTxnShares = isNaN(dialogData.beforeChangeTxnShares) ? 0 : dialogData.beforeChangeTxnShares;
            dialogData.tradeItem.txnAmt = dialogData.beforeChangeTxnAmt;
            dialogData.tradeItem.txnShares = beforeChangeTxnShares;
            dialogData.tradeItem.txnType = dialogData.beforeChangeTxnType;
            this.pros.calBasedonPOValChange(data, dialogData.tradeItem);
        } else if (dialogData.dialogFor === "closeOptionWrng") {
            const beforeChangeTxnShares = isNaN(dialogData.beforeChangeTxnShares) ? 0 : dialogData.beforeChangeTxnShares;
            dialogData.tradeItem.txnShares = beforeChangeTxnShares;
            dialogData.tradeItem.txnType = dialogData.beforeChangeTxnType;
            this.pros.calBasedonPOValChange(data, dialogData.tradeItem);
        }

        if (cbFunc) {
            cbFunc();
        } else if(dialogData.onCancel) {
            dialogData.onCancel();
            this.cancelValidation();
        }
    }

    displayPfSummryDialog(data: IPortfolioResultResponse, dialogData: IPortfolioResultDialogData, cbFunc?: Function) {
        const closeFunc: Function = () => {
            this.displayPfSummryDialogCloseFunc(data, dialogData, cbFunc)
        };

        if (dialogData.dialogFor === "fundImposedMin" || dialogData.dialogFor === "closeOptionWrng") {
            this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
                dTitle: dialogData.title,
                msg: dialogData.message,
                onProceed: closeFunc
            } as IAlertDialogData);
        } else {
            this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                severity: dialogData.isError ? 'error' : 'success',
                summary: dialogData.title,
                detail: dialogData.message
            });
        }
    }

    displayPfSummryConfDialogCloseFunc(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, dialogData: IPortfolioResultDialogData) {
        if (dialogData.dialogFor === "sellRestricn" 
        || dialogData.dialogFor === "noTradeAccount" 
        || dialogData.dialogFor === "noTradeAccountForBuyUnheldSec" 
        || dialogData.dialogFor === "equityTradeMinimum") {
            dialogData.tradeItem.txnType = dialogData.beforeChangeTxnType;
            dialogData.tradeItem.txnAmt = dialogData.beforeChangeTxnAmt;
            dialogData.tradeItem.txnShares = dialogData.beforeChangeTxnShares;

            if(dialogData.lotItem) {
                dialogData.lotItem.txnType = dialogData.lotSnapShotItem.txnType;
                dialogData.lotItem.txnAmt = dialogData.lotSnapShotItem.txnAmt;
                dialogData.lotItem.txnShares = dialogData.lotSnapShotItem.txnShares;
            }

            this.pros.calBasedonPOValChange(data, dialogData.tradeItem);

            if (dialogData.onCancel) {
                dialogData.onCancel();
                this.cancelValidation();
            }
        } else if (dialogData.dialogFor === "sellOrBuyMin" || dialogData.dialogFor === "negativeCash" || dialogData.dialogFor === "penaltyForSell") {
            dialogData.tradeItem.txnAmt = dialogData.beforeChangeTxnAmt;
            dialogData.tradeItem.txnShares = dialogData.beforeChangeTxnShares;

            if (dialogData.txnType === "SELL ALL" || dialogData.txnType === "NONE") {
                dialogData.tradeItem.txnType = dialogData.beforeChangeTxnType;
            }

            if(dialogData.lotItem) {
                dialogData.lotItem.txnType = dialogData.lotSnapShotItem.txnType;
                dialogData.lotItem.txnAmt = dialogData.lotSnapShotItem.txnAmt;
                dialogData.lotItem.txnShares = dialogData.lotSnapShotItem.txnShares;
            }

            if (dialogData.txnType === "BUY" && dialogData.beforeChangeTxnAmt === 0) {
                dialogData.tradeItem.txnType = "NONE";
                dialogData.tradeItem.txnAmt = 0;
                dialogData.tradeItem.txnShares = 0;
            }

            this.pros.calBasedonPOValChange(data, dialogData.tradeItem);

            if (dialogData.onCancel) {
                dialogData.onCancel();
                this.cancelValidation();
            }
        } else if (dialogData.dialogFor === "sellAllWrng" || dialogData.dialogFor === "fractionalShare") {
            item.txnShares = dialogData.beforeChangeTxnShares;
            item.txnAmt = dialogData.beforeChangeTxnAmt;
            item.txnType = dialogData.beforeChangeTxnType;
            
            if (dialogData.onComplete && dialogData.dialogFor === "sellAllWrng") {
                dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
            } else if (dialogData.onComplete && dialogData.dialogFor === "fractionalShare") {
                if (dialogData.onCancel) {
                    dialogData.onCancel();
                    this.cancelValidation();
                }
            }
        } else if(dialogData.dialogFor === "excluded") {
            if (dialogData.onComplete) {
                dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
            }
        }
    }

    displayPfSummryConfDialogContinueFunction(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, dialogData: IPortfolioResultDialogData) {
        if (dialogData.dialogFor === "sellRestricn") {
            if (dialogData.buyUnheldSecurity) {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "noTradeAccountForBuyUnheldSec",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "noTradeAccount",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            }
        } else if (dialogData.dialogFor === "sellOrBuyMin") {
            if (dialogData.txnType === "BUY") {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "negativeCash",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else if (dialogData.txnType === "SELL" || dialogData.txnType === "SELL ALL") {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "penaltyForSell",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (dialogData.dialogFor === "confmValidation") {
            dialogData.confmList.splice(0, 1);

            if (dialogData.confmList.length > 0) {
                const d = {} as IPortfolioResultDialogData;
                d.title = "Confirmation";
                d.dialogFor = "confmValidation";
                d.message = dialogData.confmList[0];
                d.confmList = dialogData.confmList;
                d.onComplete = dialogData.onComplete;
                this.displayPfSummryConfDialog(data, item, snapShotItem, d);
            } else {
                dialogData.onComplete();
            }
        } else if (dialogData.dialogFor === "negativeCash") {
            if (dialogData.txnType === "BUY") {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "fundImposedMin",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (dialogData.dialogFor === "equityTradeMinimum") {
            this.checkValidation({
                data: data,
                item: item,
                snapShotItem: snapShotItem,
                validnFor: "sellOrBuyMin",
                callStack: dialogData.callStack,
                onComplete: (cs: Array<string>) => {
                    this.checkValidation({
                        data: data,
                        item: item,
                        snapShotItem: snapShotItem,
                        validnFor: "sellRestricn",
                        onComplete: dialogData.onComplete,
                        callStack: cs
                    } as IPortfolioResultCheckValidationConfiguration);
                }
            });
        } else if (dialogData.dialogFor === "saveBeforeNavigating") {
            //prdRedirectManagerObj.redirectToPrevScreen(); //TODO
        } else if (dialogData.dialogFor === "reActivateResult") {
            dialogData.onComplete();
        } else if (dialogData.dialogFor === "negativeCashAndApprove" || dialogData.dialogFor === "negativeCashAndSave") {
            dialogData.onComplete();
        } else if (dialogData.dialogFor === "noTradeAccount") {
            if (item.txnAmt !== 0 && item.userTxnComplete) {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "sellOrBuyMin",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (dialogData.dialogFor === "noTradeAccountForBuyUnheldSec") {
            this.checkValidation({
                data: data,
                item: item,
                snapShotItem: snapShotItem,
                validnFor: "sellOrBuyMin",
                onComplete: dialogData.onComplete,
                callStack: dialogData.callStack
            } as IPortfolioResultCheckValidationConfiguration);
        } else if (dialogData.dialogFor === "penaltyForSell") {
            if (dialogData.txnType === "SELL") {
                this.checkValidation({
                    data: data,
                    item: item,
                    snapShotItem: snapShotItem,
                    validnFor: "negativeCash",
                    onComplete: dialogData.onComplete,
                    callStack: dialogData.callStack
                } as IPortfolioResultCheckValidationConfiguration);
            } else {
                if (dialogData.onComplete) {
                    dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
                }
            }
        } else if (dialogData.dialogFor === "sellAllWrng" || dialogData.dialogFor === "fractionalShare") {
            item.txnAmt = item.roundedMktValue;
            item.txnShares = item.currentShares;
            item.txnType = item.rebalSecId ? 'SELL ALL' : item.txnType;
            this.pros.calBasedonPOValChange(data, dialogData.tradeItem);

            if (dialogData.onComplete && dialogData.dialogFor === "sellAllWrng") {
                dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
            } else if (dialogData.onComplete && dialogData.dialogFor === "fractionalShare") {
                if(dialogData.lotItem) {
                    dialogData.lotItem.txnType = dialogData.lotSnapShotItem.txnType;
                    dialogData.lotItem.txnAmt = dialogData.lotSnapShotItem.txnAmt;
                    dialogData.lotItem.txnShares = dialogData.lotSnapShotItem.txnShares;
                }

                if (dialogData.onComplete) {
                    dialogData.onComplete(false);
                }
            }
        } else {
            if (dialogData.onComplete) {
                dialogData.onComplete(dialogData.callStack, dialogData.tradeItem);
            }
        }
    }

    displayPfSummryConfDialog(data: IPortfolioResultResponse, item: IPortfolioResultSECRebal, snapShotItem: IPortfolioResultSECRebal, dialogData: IPortfolioResultDialogData) {
        const closeFunc: Function = () => {
            this.displayPfSummryConfDialogCloseFunc(data, item, dialogData);
        };

        const continueFunction: Function = () => {
            this.displayPfSummryConfDialogContinueFunction(data, item, snapShotItem, dialogData);
        };

        this.as.fireEvent(IrbAppEvents.SHOW_CONFIRMATION, {
            dTitle: dialogData.title,
            msg: dialogData.message,
            onProceed: continueFunction,
            onCancel: closeFunc,
            dProceedBtnLabel: dialogData.proceedLabel || null,
            dCancelBtnLabel: dialogData.cancelLabel || null
        } as IAlertDialogData);
    }
}
